import React from 'react';
import {Props} from './Props';
import MessageAgeInMinutes from '../../../../../../components/MessageAgeInMinutes';
import TimeFormatted from '../../../../../../components/TimeFormatted';

const DialogWazeTrafficJams: React.FunctionComponent<Props> = ({currentProperties, showRecordIds}) => {
    return (
        <table>
            <tbody>
                {showRecordIds && (
                    <tr>
                        <th>ID</th>
                        <td>{currentProperties.id}</td>
                    </tr>
                )}
                <tr>
                    <th>Starttijd</th>
                    <td>
                        <TimeFormatted dateTime={currentProperties.startedAt} />
                    </td>
                </tr>
                <tr>
                    <th>Duur incident</th>
                    <td>
                        <MessageAgeInMinutes time={currentProperties.startedAt} />
                    </td>
                </tr>
                <tr>
                    <th>Locatie</th>
                    <td>
                        {currentProperties.address} {currentProperties.city}
                    </td>
                </tr>
                <tr>
                    <th>Filelengte</th>
                    <td>
                        {currentProperties.jamLengthInMeters}m
                    </td>
                </tr>
                <tr>
                    <th>Zwaarte</th>
                    <td>
                        {currentProperties.level} (0 = geen file, 5 = stilstaande file)
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default DialogWazeTrafficJams;
